export default {
  meta: {
    title: '保护协议和服务条款',
  },
};
